<template>
    <ProLink
        :to="{ name: 'careers-position', params: { position: position.slug } }"
        class="position-listing"
        :aria-label="`${position.title} - ${position.tagline}`"
    >
        <div class="position-listing__content" aria-hidden="true">
            <div class="position-listing__info">
                <h3 v-if="position.title" class="position-listing__heading text-heading">{{ position.title }}</h3>
                <p class="position-listing__info-meta text-subheading text-subheading--sm">{{ position.category }} | {{ position.location }}</p>
                <p v-if="position.tagline" class="text-body text-body--sm position-listing__description" v-html="position.tagline"></p>
            </div>
            <div>
                <p v-if="position.category" class="position-listing__category text-subheading text-subheading--sm">{{ position.category }}</p>
            </div>
            <div v-if="position.location" class="position-listing__location">
                <ProIcon icon="careers-location" />
                <p class="text-subheading text-subheading--sm">{{ position.location }}</p>
            </div>
        </div>
    </ProLink>
</template>

<script>
export default {
    props: {
        position: {
            default: null,
            type: Object,
        },
    },
};
</script>
